/* import __COLOCATED_TEMPLATE__ from './javascript.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();